import React from 'react'
import { useParams, Navigate } from 'react-router'
import { observer } from 'mobx-react'

// evertel
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'

const ConsumeInvite = observer(() => {

    const session = useService(SessionService)

    const {token} = useParams()

    if (token) {
        session.setPendingInviteToken(token)
    }

    // if (!session.currentUserId && token) {
    //     return <Navigate to="/register" replace />
    // }

    return (
        <Navigate to="/" replace />
    )
})

export { ConsumeInvite }
